/**
 * @generated SignedSource<<3f2224885877940683b36dd2eae3ace0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreatePersonalizedEmailTemplateInput = {
  clientMutationId?: string | null | undefined;
  data: PersonalizedEmailTemplateInput;
};
export type PersonalizedEmailTemplateInput = {
  body: string;
  key: string;
  previewText: string;
  subject: string;
  variables: ReadonlyArray<string>;
};
export type NewEmailTemplateButton_CreateMutation$variables = {
  input: CreatePersonalizedEmailTemplateInput;
};
export type NewEmailTemplateButton_CreateMutation$data = {
  readonly Admin: {
    readonly Email: {
      readonly createPersonalizedEmailTemplate: {
        readonly data: {
          readonly node: {
            readonly id: string;
          };
        };
      } | null | undefined;
    };
  };
};
export type NewEmailTemplateButton_CreateMutation = {
  response: NewEmailTemplateButton_CreateMutation$data;
  variables: NewEmailTemplateButton_CreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Email",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "CreatePersonalizedEmailTemplatePayload",
            "kind": "LinkedField",
            "name": "createPersonalizedEmailTemplate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonalizedEmailTemplatesEdge",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedEmailTemplate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NewEmailTemplateButton_CreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NewEmailTemplateButton_CreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f598e520f0e8b27fe4908b13af378ab5",
    "id": null,
    "metadata": {},
    "name": "NewEmailTemplateButton_CreateMutation",
    "operationKind": "mutation",
    "text": "mutation NewEmailTemplateButton_CreateMutation(\n  $input: CreatePersonalizedEmailTemplateInput!\n) {\n  Admin {\n    Email {\n      createPersonalizedEmailTemplate(input: $input) {\n        data {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5cfa35f3377b73a230b3826bb6cde17d";

export default node;
